export default __webpack_public_path__ + "static/media/Henri_Matisse_2020_Sales_Analysis-ARTBnk.fd4aaea7.pdf";